import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from '../api';
import Layout from '../components/Layout';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  @keyframes fadeSlideIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
  @keyframes modalIn{from{opacity:0;transform:scale(0.94) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}
  @keyframes rowIn{from{opacity:0;transform:translateX(-10px)}to{opacity:1;transform:translateX(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}
  @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(99,179,237,0.4)}50%{box-shadow:0 0 0 8px rgba(99,179,237,0)}}
  *{box-sizing:border-box}
  .rd-root{font-family:'DM Sans',sans-serif;animation:fadeSlideIn 0.5s ease both}
  .rd-input{width:100%;padding:12px 16px;background:#f8faff;border:1.5px solid #e2e8f5;border-radius:12px;
    color:#1a1d2e;font-size:15px;font-family:'DM Sans',sans-serif;outline:none;
    transition:border-color 0.2s,box-shadow 0.2s,background 0.2s;text-align:center;font-weight:600}
  .rd-input:focus{border-color:#63b3ed;background:#fff;box-shadow:0 0 0 3px rgba(99,179,237,0.15)}
  .rd-input::placeholder{color:#a0aec0;font-weight:400}
  .rd-input:disabled{background:#f0f0f0;color:#a0aec0;cursor:not-allowed}
  .rd-btn-primary{padding:12px 28px;background:linear-gradient(135deg,#63b3ed,#4299e1);
    border:none;border-radius:12px;color:#fff;font-size:14px;font-weight:700;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:transform 0.15s,box-shadow 0.15s;
    display:inline-flex;align-items:center;gap:8px;animation:pulse 2.5s ease-in-out infinite}
  .rd-btn-primary:hover{transform:translateY(-2px);box-shadow:0 8px 20px rgba(66,153,225,0.4);animation:none}
  .rd-btn-primary:disabled{opacity:0.6;cursor:not-allowed;animation:none;transform:none}
  .rd-btn-secondary{padding:12px 24px;background:#f0f4ff;border:1.5px solid #e2e8f5;
    border-radius:12px;color:#4a5568;font-size:14px;font-weight:600;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:all 0.15s}
  .rd-btn-secondary:hover{background:#e8eeff;border-color:#63b3ed;color:#3182ce}
  .rd-row{animation:rowIn 0.35s ease both}
  .rd-row:hover td{background:#f0f7ff !important;transition:background 0.15s}
  .action-btn{width:34px;height:34px;border:none;border-radius:9px;cursor:pointer;font-size:15px;
    display:inline-flex;align-items:center;justify-content:center;transition:transform 0.15s,box-shadow 0.15s}
  .action-btn:hover{transform:scale(1.18);box-shadow:0 4px 14px rgba(0,0,0,0.15)}
  .toggle-wrap{display:flex;align-items:center;gap:10px;cursor:pointer;padding:6px 12px;
    border-radius:30px;border:1.5px solid #e2e8f5;background:#f8faff;transition:all 0.2s;user-select:none}
  .toggle-wrap:hover{border-color:#63b3ed;background:#ebf8ff}
  .toggle-wrap.on{border-color:#63b3ed;background:#ebf8ff}
  .toggle-track{width:42px;height:22px;border-radius:11px;position:relative;transition:background 0.25s;flex-shrink:0}
  .toggle-thumb{position:absolute;width:16px;height:16px;border-radius:50%;background:#fff;
    top:3px;transition:left 0.25s;box-shadow:0 1px 4px rgba(0,0,0,0.2)}
  .skeleton{background:linear-gradient(90deg,#f0f4ff 25%,#e8eeff 50%,#f0f4ff 75%);
    background-size:600px 100%;animation:shimmer 1.5s infinite;border-radius:6px}
  .nav-item{display:flex;align-items:center;gap:12px;padding-top:11px;padding-bottom:11px;
    padding-left:16px;padding-right:16px;cursor:pointer;border-radius:10px;margin:2px 10px;
    color:#aaa;font-size:14px;transition:all 0.15s;white-space:nowrap}
  .nav-item:hover{background:rgba(255,255,255,0.05);color:#fff}
  .nav-item.active{background:rgba(99,179,237,0.12);color:#63b3ed;border-left:3px solid #63b3ed;padding-left:13px}
  .day-badge{display:inline-flex;align-items:center;gap:6px;padding:6px 14px;border-radius:20px;
    font-size:13px;font-weight:700}
`;


const EMPTY = { FromRentslab:'', ToRentslab:'', toMore:false };

export default function RentDurations() {
  const navigate = useNavigate();
  const location = useLocation();

  const [authUser,  setAuthUser]  = useState(null);
  const [sideOpen,  setSideOpen]  = useState(true);
  const [records,   setRecords]   = useState([]);
  const [nextFrom,  setNextFrom]  = useState(1);
  const [hasToMore, setHasToMore] = useState(false);
  const [loading,   setLoading]   = useState(true);
  const [form,      setForm]      = useState(EMPTY);
  const [editId,    setEditId]    = useState(null);
  const [saving,    setSaving]    = useState(false);
  const [toast,     setToast]     = useState(null);
  const [delModal,  setDelModal]  = useState(null);
  const [delSaving, setDelSaving] = useState(false);
  const [page,      setPage]      = useState(1);
  const PER = 10;

  useEffect(() => {
    if (!localStorage.getItem('token')) { navigate('/login'); return; }
    setAuthUser(JSON.parse(localStorage.getItem('user') || '{}'));
    fetchAll();
  }, []);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [r1, r2] = await Promise.all([
        API.get('/rent-durations'),
        API.get('/rent-durations/meta/nextfrom'),
      ]);
      setRecords(r1.data);
      setNextFrom(r2.data.nextFrom);
      setHasToMore(r2.data.hasToMore);
      // Pre-fill From field for add mode
      if (!editId) setForm(p => ({ ...p, FromRentslab: r2.data.nextFrom || '' }));
    } catch(e) { showToast('Failed to load records', 'error'); }
    setLoading(false);
  };

  const showToast = (msg, type='success') => {
    setToast({msg,type});
    setTimeout(()=>setToast(null), 3500);
  };

  const resetForm = (nf) => {
    setForm({ FromRentslab: nf || nextFrom || '', ToRentslab:'', toMore:false });
    setEditId(null);
  };

  const startEdit = (rec) => {
    setEditId(rec.RentslabId);
    setForm({
      FromRentslab: rec.FromRentslab,
      ToRentslab:   rec.ToRentslab === 1000 ? '' : rec.ToRentslab,
      toMore:       rec.ToRentslab === 1000,
    });
    window.scrollTo({top:0, behavior:'smooth'});
  };

  const handleSubmit = async () => {
    const from = parseInt(form.FromRentslab);
    const to   = form.toMore ? 1000 : parseInt(form.ToRentslab);

    if (!from || from < 1) { showToast('From Days is required', 'error'); return; }
    if (!form.toMore && (!form.ToRentslab || to < from)) {
      showToast('To Days must be ≥ From Days', 'error'); return;
    }

    setSaving(true);
    try {
      const payload = { FromRentslab: from, ToRentslab: to, toMore: form.toMore };
      if (editId) {
        await API.put(`/rent-durations/${editId}`, payload);
        showToast('Rent duration updated ✓');
      } else {
        await API.post('/rent-durations', payload);
        showToast('Rent duration added ✓');
      }
      await fetchAll();
      resetForm();
    } catch(e) {
      showToast(e.response?.data?.message || 'Operation failed', 'error');
    }
    setSaving(false);
  };

  const handleDelete = async () => {
    setDelSaving(true);
    try {
      await API.delete(`/rent-durations/${delModal.RentslabId}`);
      showToast('Rent duration deleted ✓');
      setDelModal(null);
      await fetchAll();
      resetForm();
    } catch(e) {
      showToast(e.response?.data?.message || 'Delete failed', 'error');
    }
    setDelSaving(false);
  };

  const formatRange = (rec) => {
    if (rec.ToRentslab === 1000) return `${rec.FromRentslab} Days & Above`;
    return `${rec.FromRentslab} – ${rec.ToRentslab} Days`;
  };

  const totalPages = Math.ceil(records.length / PER);
  const paged      = records.slice((page-1)*PER, page*PER);
  const logout     = () => { localStorage.clear(); navigate('/login'); };
  const maxId      = records.length > 0 ? Math.max(...records.map(r=>r.RentslabId)) : null;

  return (
    <Layout activePage="Rent Durations">
    <>
      <style>{STYLES}</style>
      <div style={S.root} className="rd-root">

        

        {/* ── Main ── */}
        <main>

          {/* Page header */}
          <div style={S.pageHeader}>
            <div>
              <h1 style={S.pageTitle}>Rent Durations</h1>
              <p style={S.pageSub}>{records.length} duration slabs configured</p>
            </div>
            <div style={S.statPill}>
              <span style={{fontSize:20}}>⏱️</span>
              <div>
                <div style={{fontSize:22,fontWeight:800,color:'#6C63FF',lineHeight:1}}>{records.length}</div>
                <div style={{fontSize:11,color:'#a0aec0',fontWeight:600,textTransform:'uppercase'}}>Total Slabs</div>
              </div>
            </div>
          </div>

          {/* ── Add / Edit Form Card ── */}
          <div style={S.formCard}>
            <div style={S.formCardHead}>
              <div style={S.formCardIcon}>{editId ? '✏️' : '➕'}</div>
              <div>
                <h2 style={S.formCardTitle}>{editId ? 'Edit Rent Duration' : 'Add Rent Duration'}</h2>
                <p style={S.formCardSub}>
                  {editId
                    ? 'Modify the selected duration slab below'
                    : hasToMore
                      ? 'A "To More" slab already exists. Delete it first to add more.'
                      : `Next From value starts at Day ${nextFrom}`}
                </p>
              </div>
              {editId && (
                <button className="rd-btn-secondary" style={{marginLeft:'auto'}}
                  onClick={()=>resetForm()}>
                  ✕ Cancel Edit
                </button>
              )}
            </div>

            {hasToMore && !editId ? (
              <div style={S.warningBox}>
                ⚠️ A <strong>"To More"</strong> (unlimited) slab already exists.
                Delete the highest slab first to add a new one.
              </div>
            ) : (
              <div style={S.formRow}>
                {/* From Days */}
                <div style={S.fieldBox}>
                  <label style={S.fieldLabel}>FROM — Days *</label>
                  <input
                    className="rd-input"
                    type="number" min="1" max="999"
                    placeholder="e.g. 1"
                    value={form.FromRentslab}
                    onChange={e=>setForm(p=>({...p,FromRentslab:e.target.value}))}
                    style={{borderColor:'#63b3ed',background:'#ebf8ff'}}
                  />
                  <div style={S.fieldHint}>Starting day of this slab</div>
                </div>

                {/* Arrow */}
                <div style={S.arrow}>→</div>

                {/* To Days / Toggle */}
                <div style={S.fieldBox}>
                  <label style={S.fieldLabel}>TO — Days *</label>
                  <input
                    className="rd-input"
                    type="number" min="1" max="999"
                    placeholder={form.toMore ? '∞ Unlimited' : 'e.g. 6'}
                    value={form.toMore ? '' : form.ToRentslab}
                    disabled={form.toMore}
                    onChange={e=>setForm(p=>({...p,ToRentslab:e.target.value}))}
                    style={form.toMore?{borderColor:'#a0aec0',background:'#f0f0f0',color:'#a0aec0'}:{}}
                  />
                  <div style={S.fieldHint}>Ending day of this slab</div>
                </div>

                {/* To More Toggle */}
                <div style={S.fieldBox}>
                  <label style={S.fieldLabel}>OPEN-ENDED</label>
                  <div
                    className={`toggle-wrap${form.toMore?' on':''}`}
                    onClick={()=>setForm(p=>({...p,toMore:!p.toMore,ToRentslab:''}))}
                  >
                    <div className="toggle-track"
                      style={{background:form.toMore?'#63b3ed':'#e2e8f0'}}>
                      <div className="toggle-thumb"
                        style={{left:form.toMore?'22px':'4px'}}/>
                    </div>
                    <span style={{fontSize:13,fontWeight:600,color:form.toMore?'#2b6cb0':'#718096'}}>
                      {form.toMore ? '✓ To More (∞)' : 'Set specific days'}
                    </span>
                  </div>
                  <div style={S.fieldHint}>Enable for unlimited upper range</div>
                </div>

                {/* Submit */}
                <div style={{...S.fieldBox,justifyContent:'flex-end'}}>
                  <label style={S.fieldLabel}>&nbsp;</label>
                  <button className="rd-btn-primary" onClick={handleSubmit} disabled={saving}>
                    {saving
                      ? <span style={S.spinner}/>
                      : editId ? '💾 Update Slab' : '＋ Add Slab'}
                  </button>
                  {editId && (
                    <button className="rd-btn-secondary" style={{marginTop:8}}
                      onClick={()=>resetForm()}>Clear</button>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* ── Records Table ── */}
          <div style={S.tableCard}>
            <div style={S.tableCardHead}>
              <h3 style={S.tableCardTitle}>📋 Manage Rent Durations</h3>
              <span style={S.recCount}>{records.length} slabs</span>
            </div>

            <table style={S.table}>
              <thead>
                <tr style={{background:'linear-gradient(135deg,#f8faff,#f0f4ff)'}}>
                  {['#','Duration Range','From Day','To Day','Type','Actions'].map(h=>(
                    <th key={h} style={S.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading
                  ? Array.from({length:5}).map((_,i)=>(
                      <tr key={i}>
                        {Array.from({length:6}).map((_,j)=>(
                          <td key={j} style={S.td}>
                            <div className="skeleton" style={{height:14,width:'70%'}}/>
                          </td>
                        ))}
                      </tr>
                    ))
                  : paged.length===0
                  ? (
                      <tr>
                        <td colSpan={6} style={{textAlign:'center',padding:'48px 0',color:'#a0aec0'}}>
                          <div style={{fontSize:40,marginBottom:10}}>⏱️</div>
                          <div style={{fontSize:15,fontWeight:600}}>No rent durations added yet</div>
                          <div style={{fontSize:13,marginTop:4}}>Use the form above to add your first slab</div>
                        </td>
                      </tr>
                    )
                  : paged.map((rec,i)=>{
                      const isMax = rec.RentslabId === maxId;
                      const isToMore = rec.ToRentslab === 1000;
                      return (
                        <tr key={rec.RentslabId} className="rd-row"
                          style={{borderBottom:'1px solid #f0f4ff',
                            background: editId===rec.RentslabId ? '#fffbf0' : i%2===0?'#fff':'#fafbff'}}>
                          <td style={{...S.td,color:'#a0aec0',fontWeight:700,fontSize:12}}>
                            {(page-1)*PER+i+1}
                          </td>
                          <td style={S.td}>
                            <div style={{display:'flex',alignItems:'center',gap:10}}>
                              <div style={{width:36,height:36,borderRadius:10,
                                background:isToMore?'linear-gradient(135deg,#667eea,#764ba2)':'linear-gradient(135deg,#63b3ed,#4299e1)',
                                display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,flexShrink:0}}>
                                {isToMore?'∞':'📅'}
                              </div>
                              <div>
                                <div style={{fontWeight:700,fontSize:14,color:'#1a1d2e'}}>
                                  {formatRange(rec)}
                                </div>
                                {isMax && (
                                  <span style={{fontSize:10,background:'#fefcbf',color:'#744210',
                                    padding:'2px 6px',borderRadius:10,fontWeight:700}}>
                                    LATEST
                                  </span>
                                )}
                              </div>
                            </div>
                          </td>
                          <td style={S.td}>
                            <span className="day-badge"
                              style={{background:'#ebf8ff',color:'#2b6cb0'}}>
                              Day {rec.FromRentslab}
                            </span>
                          </td>
                          <td style={S.td}>
                            <span className="day-badge"
                              style={isToMore?{background:'#faf5ff',color:'#6b46c1'}:{background:'#f0fff4',color:'#276749'}}>
                              {isToMore ? '∞ No Limit' : `Day ${rec.ToRentslab}`}
                            </span>
                          </td>
                          <td style={S.td}>
                            <span className="day-badge"
                              style={isToMore?{background:'#faf5ff',color:'#553c9a',border:'1.5px solid #d6bcfa'}:{background:'#e6fffa',color:'#2c7a7b',border:'1.5px solid #81e6d9'}}>
                              {isToMore?'Open-Ended':'Fixed Range'}
                            </span>
                          </td>
                          <td style={S.td}>
                            <div style={{display:'flex',gap:8,alignItems:'center'}}>
                              <button className="action-btn"
                                style={{background:'#fefcbf',color:'#744210'}}
                                title="Edit" onClick={()=>startEdit(rec)}>✏️</button>
                              <button className="action-btn"
                                style={{
                                  background: isMax?'#fff5f5':'#f0f0f0',
                                  color: isMax?'#c53030':'#a0aec0',
                                  cursor: isMax?'pointer':'not-allowed',
                                  opacity: isMax?1:0.5
                                }}
                                title={isMax?'Delete':'Only the latest slab can be deleted'}
                                onClick={()=>isMax&&setDelModal(rec)}>🗑</button>
                              {!isMax && (
                                <span style={{fontSize:11,color:'#a0aec0',whiteSpace:'nowrap'}}>
                                  Delete latest first
                                </span>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                }
              </tbody>
            </table>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={S.pagination}>
                <span style={{fontSize:13,color:'#718096'}}>
                  Showing {(page-1)*PER+1}–{Math.min(page*PER,records.length)} of {records.length}
                </span>
                <div style={{display:'flex',gap:6}}>
                  <button style={S.pageBtn} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                  {Array.from({length:totalPages},(_,i)=>i+1).map(p=>(
                    <button key={p} style={{...S.pageBtn,...(p===page?S.pageBtnActive:{})}}
                      onClick={()=>setPage(p)}>{p}</button>
                  ))}
                  <button style={S.pageBtn} disabled={page===totalPages} onClick={()=>setPage(p=>p+1)}>Next →</button>
                </div>
              </div>
            )}
          </div>

          {/* ── Info box ── */}
          <div style={S.infoBox}>
            <div style={{fontSize:20,marginBottom:6}}>💡</div>
            <div>
              <strong style={{color:'#2b6cb0'}}>How Rent Duration Slabs Work</strong>
              <p style={{fontSize:13,color:'#4a5568',margin:'6px 0 0',lineHeight:1.6}}>
                Slabs define pricing tiers based on rental duration. For example: <strong>1–3 days</strong>, <strong>4–7 days</strong>, <strong>8+ days</strong>.
                Each slab is used in the tariff configuration. Only the <strong>highest slab</strong> can be deleted (to maintain referential integrity).
                Use <strong>To More</strong> for an open-ended upper range.
              </p>
            </div>
          </div>
        </main>

        {/* ── Delete Confirmation Modal ── */}
        {delModal && (
          <div style={S.overlay} onClick={()=>setDelModal(null)}>
            <div style={{...S.modal,maxWidth:420}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:'36px 32px',textAlign:'center'}}>
                <div style={{fontSize:52,marginBottom:16}}>🗑️</div>
                <h2 style={{fontSize:20,fontWeight:800,color:'#1a1d2e',marginBottom:8}}>Delete Slab?</h2>
                <div style={{marginBottom:16}}>
                  <span className="day-badge" style={{background:'#ebf8ff',color:'#2b6cb0',fontSize:15}}>
                    {formatRange(delModal)}
                  </span>
                </div>
                <p style={{color:'#718096',fontSize:14,lineHeight:1.7,marginBottom:28}}>
                  This will also remove related tariff records.<br/>
                  <strong style={{color:'#e53e3e'}}>This action cannot be undone.</strong>
                </p>
                <div style={{display:'flex',gap:12,justifyContent:'center'}}>
                  <button className="rd-btn-secondary" onClick={()=>setDelModal(null)}>Cancel</button>
                  <button disabled={delSaving} onClick={handleDelete} style={{
                    padding:'12px 24px',background:'linear-gradient(135deg,#fc8181,#e53e3e)',
                    border:'none',borderRadius:12,color:'#fff',fontWeight:700,fontSize:14,
                    fontFamily:'DM Sans,sans-serif',cursor:'pointer',
                    display:'flex',alignItems:'center',gap:8}}>
                    {delSaving?<span style={S.spinner}/>:'🗑️ Delete Permanently'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Toast ── */}
        {toast && (
          <div style={{...S.toast,
            background:toast.type==='error'?'#fff5f5':'#f0fff4',
            borderColor:toast.type==='error'?'#fc8181':'#68d391',
            color:toast.type==='error'?'#c53030':'#276749'}}>
            {toast.type==='error'?'⚠️':'✅'} {toast.msg}
          </div>
        )}
      </div>
    </>
    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
  root:{display:'flex',minHeight:'100vh',background:'#f4f6fb'},
  
  main:{flex:1,padding:'28px',minWidth:0},

  pageHeader:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:24},
  pageTitle:{fontSize:26,fontWeight:800,color:'#1a1d2e',letterSpacing:'-0.5px',margin:0,fontFamily:"'Syne',sans-serif"},
  pageSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  statPill:{display:'flex',alignItems:'center',gap:14,background:'#fff',borderRadius:16,
    padding:'16px 22px',boxShadow:'0 2px 12px rgba(0,0,0,0.06)',border:'1.5px solid #e8eeff'},

  formCard:{background:'#fff',borderRadius:20,padding:'28px',
    boxShadow:'0 4px 24px rgba(0,0,0,0.07)',marginBottom:24,
    border:'1.5px solid #e8eeff'},
  formCardHead:{display:'flex',alignItems:'flex-start',gap:16,marginBottom:24},
  formCardIcon:{width:48,height:48,background:'linear-gradient(135deg,#63b3ed,#4299e1)',
    borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',
    fontSize:22,flexShrink:0,boxShadow:'0 4px 14px rgba(99,179,237,0.35)'},
  formCardTitle:{fontSize:18,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  formCardSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},

  formRow:{display:'grid',gridTemplateColumns:'1fr 40px 1fr 1fr 160px',gap:16,alignItems:'start'},
  fieldBox:{display:'flex',flexDirection:'column',gap:6},
  fieldLabel:{fontSize:11,fontWeight:700,color:'#718096',textTransform:'uppercase',letterSpacing:'0.5px'},
  fieldHint:{fontSize:11,color:'#a0aec0'},
  arrow:{display:'flex',alignItems:'center',justifyContent:'center',paddingTop:36,
    fontSize:22,color:'#63b3ed',fontWeight:700},

  warningBox:{background:'#fffbeb',border:'1.5px solid #f6e05e',borderRadius:12,
    padding:'16px 20px',color:'#744210',fontSize:14,lineHeight:1.6},

  tableCard:{background:'#fff',borderRadius:20,overflow:'hidden',
    boxShadow:'0 4px 24px rgba(0,0,0,0.07)',marginBottom:20,border:'1.5px solid #e8eeff'},
  tableCardHead:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'20px 24px',borderBottom:'1px solid #f0f4ff'},
  tableCardTitle:{fontSize:16,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  recCount:{fontSize:12,background:'#f3f2ff',color:'#6C63FF',borderRadius:20,
    padding:'4px 14px',fontWeight:700},

  table:{width:'100%',borderCollapse:'collapse'},
  th:{padding:'14px 20px',fontSize:11,fontWeight:700,color:'#718096',textAlign:'left',
    textTransform:'uppercase',letterSpacing:'0.5px',borderBottom:'2px solid #e8eeff'},
  td:{padding:'14px 20px',fontSize:13,color:'#4a5568',verticalAlign:'middle'},

  pagination:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'16px 24px',borderTop:'1px solid #f0f4ff'},
  pageBtn:{padding:'6px 12px',border:'1.5px solid #e2e8f5',borderRadius:8,background:'#fff',
    color:'#718096',fontSize:13,fontWeight:600,cursor:'pointer',
    fontFamily:'DM Sans,sans-serif',transition:'all 0.15s'},
  pageBtnActive:{background:'#63b3ed',borderColor:'#63b3ed',color:'#fff'},

  infoBox:{background:'linear-gradient(135deg,#ebf8ff,#e6fffa)',borderRadius:16,
    padding:'20px 24px',border:'1.5px solid #90cdf4',display:'flex',gap:16,alignItems:'flex-start'},

  overlay:{position:'fixed',inset:0,background:'rgba(10,15,40,0.6)',zIndex:200,
    display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(4px)',padding:'20px'},
  modal:{background:'#fff',borderRadius:20,width:'100%',maxWidth:620,
    boxShadow:'0 32px 80px rgba(0,0,0,0.25)',animation:'modalIn 0.3s ease both'},

  spinner:{display:'inline-block',width:16,height:16,border:'2px solid rgba(255,255,255,0.3)',
    borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.6s linear infinite'},
  toast:{position:'fixed',bottom:28,right:28,zIndex:999,padding:'14px 22px',
    borderRadius:12,border:'1.5px solid',fontSize:14,fontWeight:600,
    fontFamily:'DM Sans,sans-serif',boxShadow:'0 8px 24px rgba(0,0,0,0.1)',
    animation:'fadeSlideIn 0.3s ease'},
};